import { setToken, setCookie, removeToken } from '@/utils/token'
const state = {
    Token: '',
    userInfo:{},
    currentRoute:'',
    isTicket: false,
    isToken: false,
}
const mutations = {
    SET_TOKEN(state, token) {
        state.Token = token
    },
    SET_USERINFO(state,info){
        state.userInfo = info
    },
    SET_CURRENTROUTE(state,route){
        state.currentRoute = route
    },
    SET_ISTICKET(state, isTicket){
        state.isTicket = isTicket
    },
    SET_ISTOKEN(state, isToken){
        state.isToken = isToken
    }
}
const actions = {
    login({ commit }, token){
        setToken(token)
        setCookie('mobileToken',token)
        commit('SET_TOKEN', token)
    },
    restToken({ commit }) {
        return new Promise(resolve => {
            commit('SET_TOKEN', '')
            commit('SET_USERINFO', {})
            removeToken()
            resolve()
        })
    },
    setUserInfo({ commit },info){
        console.log(info)
        commit('SET_USERINFO', info)
    },
    setCurrentRoute({ commit },route){
        commit('SET_CURRENTROUTE', route)
    },
    setIsTicket({commit}, isTicket){
        commit('SET_ISTICKET', isTicket)
    },
    setIsToken({commit}, isToken){
        commit('SET_ISTOKEN', isToken)
    }
}
const getters={
    userInfo: state => state.userInfo,
    token: state => state.Token,
    isTicket: state => state.isTicket,
    isToken: state => state.isToken
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
